module.exports = __webpack_public_path__ + "static/media/Pointerbox.b787e4cf.png";